<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-cart">
    <div class="vx-col w-full sm:w-3/4 md:w-2/3 lg:w-3/4 xl:w-3/5">
      <vx-card title="Order Form" title-color="primary" >
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-6">

                <div class="vx-card__title mb-4 text-center">
                  <h5 class="mb-4">Dear <strong >buyerName{{ buyerName }}</strong>,<br>This is your Order Details.</h5>
                </div>

                <vs-divider/>

                <div>
                  <h5>Seller Company</h5>

                  <p class="mt-4"><strong>Bill to:</strong></p>
                  <p class="mt-2">buyerName{{ buyerName }}</p>
                  <p class="mt-2">phoneNumber{{ phoneNumber }}</p>

                  <vs-button type="border" icon-pack="feather" icon="icon-plus" size="small" class="mt-4" @click="billingPopup=true">add address</vs-button>
                  <vs-popup title="Billing Address" :active.sync="billingPopup">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mb-2">
                        <vs-input class="w-full" label-placeholder="First Name" v-model="buyerFirstName" />
                        </div>
                        <div class="vx-col md:w-1/2 w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Last Name" v-model="buyerLastName" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Address Line 1" v-model="buyerAddressOne" />
                        </div>
                        <div class="vx-col w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Address Line 2" v-model="buyerAddressTwo" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Country" v-model="buyerCountry" />
                        </div>
                        <div class="vx-col md:w-1/2 w-full mb-2">
                        <vs-input class="w-full" label-placeholder="State" v-model="buyerState" />
                        </div>
                        <div class="vx-col md:w-1/2 w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Postcode" v-model="buyerPostcode" />
                        </div>
                        <div class="vx-col md:w-1/2 w-full mb-2">
                        <vs-input class="w-full" label-placeholder="City" v-model="buyerCity" />
                        </div>
                    </div>
                    <div>
                      <div class="centerx mt-4 md:flex">
                        <vs-button type="border" icon-pack="feather" icon="icon-x" >Cancel</vs-button>
                        <vs-button type="filled" icon-pack="feather" icon="icon-check" class="shadow-md ml-auto" >Save</vs-button>
                      </div>
                    </div>
                  </vs-popup>

                  <vs-divider/>

                  <vs-table :data="users" class="table-auto">

                    <template slot="thead">
                    <vs-th class="hidden md:table-cell">Description</vs-th>
                    <vs-th class="hidden md:table-cell">Price</vs-th>
                    <vs-th class="md:hidden">Details</vs-th>
                    <vs-th>Amount</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].productDescription" class="hidden md:table-cell">
                        {{ data[indextr].productDescription }}
                        </vs-td>

                        <vs-td :data="data[indextr].productPrice" class="hidden md:table-cell">
                        {{ data[indextr].productPrice }}
                        </vs-td>

                        <vs-td class="md:hidden">
                          {{ data[indextr].productDescription }}<br />
                          {{ data[indextr].productPrice }}
                        </vs-td>

                        <vs-td :data="data[indextr].productAmount">
                        {{ data[indextr].productAmount }}
                        </vs-td>
                    </vs-tr>
                    </template>

                  </vs-table>

                  <div class="mt-4">
                    <vs-button class="mx-auto" type="border" icon-pack="feather" icon="icon-arrow-right" icon-after size="small">Continue Shopping</vs-button>
                  </div>

                  <vs-divider/>

                  <div class="vx-row">
                    <div class="vx-col w-1/2 md:w-1/2 lg:w-4/5 text-right">
                      <p>Sub Total :</p>
                      <p>Tax :</p>
                      <p><strong>Total :</strong></p>
                      <p>Amount Paid :</p>
                      <p>Coupon Code :</p>
                    </div>
                    <div class="vx-col w-1/2 md:w-1/2 lg:w-1/5 text-right">
                      <p>RM 60.00</p>
                      <p>0 %</p>
                      <p><strong>RM 60.00</strong></p>
                      <p>RM 0.00</p>
                      <p><a class="cursor-pointer" @click="couponPopup=true">Select Coupon</a></p>
                    </div>
                  </div>
                  <vs-popup title="Billing Address" :active.sync="couponPopup">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Enter Code Here" v-model="couponCode" />
                        </div>
                    </div>
                    <div>
                      <div class="centerx mt-4 md:flex">
                        <vs-button type="border" icon-pack="feather" icon="icon-x" >Cancel</vs-button>
                        <vs-button type="filled" icon-pack="feather" icon="icon-check" class="shadow-md ml-auto" >Apply</vs-button>
                      </div>
                    </div>
                  </vs-popup>

                  <vs-divider/>

                  <div class="centerx mt-4 text-center">
                    <small>Check all details before proceeding to Payment</small>
                    <vs-button type="filled" icon-pack="feather" icon="icon-arrow-right" icon-after class="w-full mt-2 shadow-md" @click.prevent="$router.push({name: 'buyer-address'})">Proceed</vs-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [
          {
            'id': 1,
            'productDescription':  'product 1 x 2',
            'productPrice':        'RM 99.00',
            'productAmount':       'RM 198.00'
          },
          {
            'id': 2,
            'productDescription':  'product 2 x 4',
            'productPrice':        'RM 49.00',
            'productAmount':       'RM 196.00'
          },
          {
            'id': 3,
            'productDescription':  'product 3 x 1',
            'productPrice':        'RM 159.00',
            'productAmount':       'RM 159.00'
          },
      ],
      billingPopup: false,
      billingFirstName: "",
      billingLastName: "",
      billingAddressOne: "",
      billingAddressTwo: "",
      billingCountry: "",
      billingState: "",
      billingPostcode: "",
      billingCity: "",
      couponPopup: false,
      couponCode: ""
    }
  }
}
</script>

<style>

@media screen and (max-width:576px) {
    .vs-table--tbody-table {min-width: auto; }
    .router-view { padding: 0.5rem !important; }
}
</style>